@if (showBanner) {
  <div>
    @for (duplicate of duplicates; track duplicate) {
      <div class="dupe-banner">
        @if (!duplicate.dismissed) {
          <se-po-duplicate-banner-instance
            [duplicate]="duplicate"
            (dismiss)="dismissBanner(duplicate)"
            (merge)="onMerge(duplicate)">
          </se-po-duplicate-banner-instance>
        }
      </div>
    }
  </div>
}
